<template>
  <section>
    <div class="icon-container" @click="togglePortfolio = !togglePortfolio">
      <font-awesome-icon class="icon-button" icon="edit"
        >Rediger</font-awesome-icon
      >
    </div>
    <div class="portfolio-header">
      <h2 class="title">
        <font-awesome-icon class="colored-icon" icon="suitcase" />
        Portfolio
      </h2>
    </div>

    <div class="portfolio-box-container">
      <div class="projects">
        <ProfileProjectCard
          v-for="(project, index) in userInfo.portfolio"
          :key="project.projectId"
          :project="project"
          :index="index"
          :edit="togglePortfolio"
          @deleted="getUserPortfolio"
        />

        <div class="project-box">
          <button
            class="add-project"
            @click="$router.push('/prosjekter/rediger')"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileProjectCard from "@/components/ProfileProjectCard";
export default {
  name: "PortfolioComponent",
  data() {
    return {
      togglePortfolio: false,
    };
  },
  components: {
    ProfileProjectCard,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions(["getUserPortfolio"]),
  },
  watch: {
    togglePortfolio: function () {
      var box = document.getElementsByClassName("project-box");
      var pluss = document.getElementsByClassName("add-project");
      if (this.togglePortfolio) {
        box[0].style.backgroundColor = "rgba(50, 50, 50, 0.5)";
        pluss[0].style.backgroundColor = "#cacaca";
      } else {
        box[0].style.backgroundColor = "#d1d1d1";
        pluss[0].style.backgroundColor = "#dcdcdc";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.portfolio-header {
  display: flex;
}

.projects {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin: auto;
}

.project-box {
  margin-bottom: 15px;
  padding: 60px;
  background-color: #d1d1d1;

  & > .add-project {
    margin: auto;
    height: 100px;
    width: 100px;
    font-size: 50px;
    color: var(--dark-color);
    border-radius: 100%;
    background-color: #dcdcdc;
  }
}
</style>